import React, {Component} from 'react';
import {Link} from 'react-router-dom';

const FooterMiddle = () => {

  return (
    <div className="footer-middle">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <div className="row">
              <div className="col-sm-6 col-md-5 col-lg-6">
                <div className="nav-title">Visit Us</div>
                <ul>
                  <li>Jasons Wine & Spirits</li>
                  <li>828 s. Main Street,</li>
                  <li>Los Angeles, CA 90014</li>
                  <li>213-485-9463</li>
                  <li>
                    <a href="#" className="highlighted">info@jasonsliquor.com</a>
                  </li>
                </ul>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-6">
                <div className="nav-title">Hours of Operation</div>
                <ul>
                  <li>Mon – Sun: 9am to 2am</li>
                  <li>365 days!<br />Delivery available ALL DAY!</li>
                </ul>
              </div>
              <div className="col-md-3 tab-nav-col ">
                <div className="nav-title">Social</div>
                <ul>
                  <li><i className="fa fa-twitter"/>
                <a href="https://twitter.com/@jasonsliquor" aria-label="jasonsliquor twitter link" target="_blank">Twitter</a>
                  </li>
                  <li><i className="fa fa-facebook"/>
                  <a href="https://www.facebook.com/jasonsliquor/" aria-label="jasonsliquor facebook link" target="_blank">
                      Facebook</a>
                  </li>
                  <li>
                    <a href="https://www.yelp.com/biz/jasons-wine-and-spirits-los-angeles" aria-label="jasonsliquor yelp link" target="_blank"><i className="fa fa-yelp"/>
                      Yelp</a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/jasonsliquor/"  aria-label="jasonsliquor instagram link" target="_blank"><i className="fa fa-instagram"/>
                      Instagram</a>
                  </li>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="row">
              <div className="col-sm-6 col-md-5 col-lg-3">
                <div className="nav-title">Company</div>
                <ul>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  <li></li>
                </ul>
              </div>
              <div className="col-sm-6 col-md-4 desktop-nav-col">
                <div className="nav-title">Social</div>
                <ul>
                  <li><i className="fa fa-twitter"/>
                    <a href="https://twitter.com/@jasonsliquor" aria-label="jasonsliquor twitter link" target="_blank">Twitter</a>
                  </li>
                  <li><i className="fa fa-facebook"/>
                  <a href="https://www.facebook.com/jasonsliquor/" aria-label="jasonsliquor facebook link" target="_blank">
                      Facebook</a>
                  </li>
                  <li>
                    <a href="https://www.yelp.com/biz/jasons-wine-and-spirits-los-angeles" aria-label="jasonsliquor yelp link" target="_blank"><i className="fa fa-yelp"/>
                      Yelp</a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/jasonsliquor/" aria-label="jasonsliquor instagram link" target="_blank"><i className="fa fa-instagram"/>
                      Instagram</a>
                  </li>
                  <li></li>
                </ul>
              </div>
              <div className="col-md-5">
                <div className="nav-title">Legal</div>
                <ul>
                  {/* <li>
                    <a href="#">Delivery info</a>
                  </li> */}
                  <li>
                    <Link to="/tos">Terms &amp; Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterMiddle;



// WEBPACK FOOTER //
// ./src/components/commons/footer/FooterMiddle.js